import { Button } from '@/global/components/Button'
import Menu from '@/global/components/MenuV2'
import { SelectLocais as LocaisComponent } from '@/global/components/Selects'
import { SelectCentroCusto as CCComponent } from '@/global/components/Selects/SelectCentroCusto'
import { SelectEmpresa as EmpresaComponent } from '@/global/components/Selects/SelectEmpresa'
import { SelectFuncionario as FuncionarioComponent } from '@/global/components/Selects/SelectFuncionario'
import { SelectLocal as LocalComponent } from '@/global/components/Selects/SelectLocal'
import { cn } from '@/lib/utils'
import { ListFilterPlusIcon } from 'lucide-react'
import React from 'react'

interface IProps {
    SelectEmpresas?: React.ComponentProps<typeof EmpresaComponent> | boolean
    SelectCentroCusto?: React.ComponentProps<typeof CCComponent> | boolean
    SelectLocal?: React.ComponentProps<typeof LocalComponent> | boolean
    SelectLocais?: React.ComponentProps<typeof LocaisComponent> | boolean
    SelectFuncionario?:
        | React.ComponentProps<typeof FuncionarioComponent>
        | boolean
    children?: React.ReactNode
    childFirst?: boolean
}

// Função auxiliar para retornar props ou um objeto vazio, conforme necessário
function propsOrNothing<T>(props: T | boolean): T | NonNullable<any> {
    return typeof props === 'boolean' ? {} : props
}

export default function FiltrosPadrao({
    SelectEmpresas: SelectEmpresasProps,
    SelectCentroCusto: SelectCentroCustoProps,
    SelectLocal: SelectLocalProps,
    SelectLocais: SelectLocaisProps,
    SelectFuncionario: SelectFuncionarioProps,
    children,
    childFirst = false,
}: IProps) {
    const components: React.ReactNode[] = [
        SelectEmpresasProps ? (
            <EmpresaComponent
                key="select-empresa"
                width={240}
                hideWhenSingle
                {...propsOrNothing(SelectEmpresasProps)}
            />
        ) : null,
        SelectCentroCustoProps ? (
            <CCComponent
                key="select-centro-custo"
                width={240}
                {...propsOrNothing(SelectCentroCustoProps)}
            />
        ) : null,
        SelectLocalProps ? (
            <LocalComponent
                key="select-local"
                width={240}
                {...propsOrNothing(SelectLocalProps)}
            />
        ) : null,
        SelectLocaisProps ? (
            <LocaisComponent
                key="select-locais"
                width={240}
                {...propsOrNothing(SelectLocaisProps)}
            />
        ) : null,
        SelectFuncionarioProps ? (
            <FuncionarioComponent
                key="select-funcionario"
                width={240}
                {...propsOrNothing(SelectFuncionarioProps)}
            />
        ) : null,
    ]

    if (children) {
        if (childFirst) components.unshift(children)
        else components.push(children)
    }

    const componentesNaoVazios = components.filter(Boolean).length

    return componentesNaoVazios > 1 ? (
        [
            <div
                key="desktop-filtros"
                className={cn(
                    'gap-1 hidden',
                    componentesNaoVazios > 3 ? 'xl:flex' : 'lg:flex',
                )}
            >
                {components}
            </div>,
            <div
                key="mobile-filtros"
                className={cn(
                    'flex',
                    componentesNaoVazios > 3 ? 'xl:hidden' : 'lg:hidden',
                )}
            >
                <Menu.Root arrow position="right">
                    <Menu.Trigger>
                        <Button
                            variant="outlined"
                            className="text-nowrap gap-2"
                        >
                            <ListFilterPlusIcon />
                            Filtros
                        </Button>
                    </Menu.Trigger>
                    <Menu.Popover>
                        <div
                            className={cn(
                                'flex flex-col',
                                'gap-x-2 gap-y-3 p-2',
                                'rounded-sm',
                                '*:w-full sm:*:w-64',
                                'max-h-96 overflow-y-auto',
                            )}
                        >
                            {components}
                        </div>
                    </Menu.Popover>
                </Menu.Root>
            </div>,
        ]
    ) : (
        <div className="flex gap-1">{components}</div>
    )
}
